import React from 'react';

function subArabElectricians() {
  return (
    <div className="container">
            <div className="row EmpContentHeader styleAllowable">
            
                <div className="col-1">
                    <span>ActivityID</span>
                </div>
                <div className="col-2 DCenter">
                    <span>Job Card No.</span>
                </div>
                <div className="col-1 DCenter">
                    <span>Date</span>
                </div>
                <div className="col-2 DCenter">
                    <span>Description</span>
                </div>
                <div className="col-1 DCenter">
                    <span>Cty</span>
                </div>
                <div className="col-1 DCenter">
                    <span>Zone</span>
                </div>
                <div className="col-2 DCenter">
                    <span>Comments</span>
                </div>
                <div className="col-1 DCenter">
                    <span>Photo</span>
                </div>
                <div className="col-1 DEnd">
                    <span>Status</span>
                </div>
            </div>
        </div>
  )
}

export default subArabElectricians;